import { DownloadOutlined } from "@ant-design/icons";
import { header } from "../../utils/salesAdminHeader";
import { apiCall } from "../../../../utils/apiCall";

const FileDownload = ({
  fileName,
  fileUrl,
  fileId,
  base64,
  contentType,
  index,
}: {
  fileName: string;
  fileUrl?: string;
  fileId?: number;
  base64?: string;
  contentType?: string;
  index: number;
}) => {
  const handleDownload = async () => {
    if (fileUrl) {
      // 普通 blob 下載
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName;
      link.click();
    } else if (fileId !== null || base64) {
      try {
        // call API 取得 base64
        let base64Data;
        let finalContentType;
        if (fileId) {
          const res = await apiCall({
            method: "GET",
            endPoint: `${process.env.REACT_APP_SALES_ADMIN}/files/admin/${fileId}`,
            header: header,
          });
          if (res) {
            base64Data = res.data;
            finalContentType = res.contentType;
          }
        } else {
          base64Data = base64;
          finalContentType = contentType;
        }

        // 建立 blob 並觸發下載
        const blob = await (
          await fetch(`data:${finalContentType};base64,${base64Data}`)
        ).blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div
      style={{
        border: "1px solid #d9d9d9",
        padding: "8px 12px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        width: 600,
        marginTop: index !== 0 ? 20 : 0,
      }}
      onClick={handleDownload}
    >
      <DownloadOutlined className="mr-5" />
      <span>{fileName}</span>
    </div>
  );
};

export default FileDownload;
